import { InternalCompilerError } from './InternalCompilerError';
import { AbstractBlock } from "./assemblyBlocks/AbstractBlock";
import { VoidBlock } from "./assemblyBlocks/VoidBlock";

var interuptSignal = false; // stop signal

/**
 * Class for a user-created program.
 */
export class Program {
    subroutines: AbstractBlock[];
    triggerDict: Map<string, number[]>;
    varEnv: Map<string, any>;

    triggeredIndexes: Set<number>;

    taskQueue: [IterableIterator<void>, number][];

    // function that gets called when an error happens. Should be injected
    errorNotify: (message: string, ...nodeId: string[]) => void;

    /**
     * Constructor
     * @param subroutines list of abstract block trees in order (including triggered subroutines)/
     */
    constructor(subroutines: AbstractBlock[], triggerDict: Map<string, number[]>) {
        this.subroutines = subroutines;
        this.triggerDict = triggerDict;
        this.varEnv = new Map();
        this.taskQueue = [];
        this.errorNotify = (message: string, ...nodeId: string[]) => { console.log('Unhandled Runtime Error') };

        this.triggeredIndexes = new Set();

        triggerDict.forEach((ixArr) => {
            ixArr.forEach(ix => this.triggeredIndexes.add(ix));
        })

        console.log('trigger map');
        console.log(triggerDict);

        console.log(`THERE ARE ${this.subroutines.length} subroutines`);
    }

    /**
     * Runs the subroutines triggered by trigName, in order.
     * Does not clear varEnv.
     * 
     * @param trigName the name of the trigger
     */
    trigger(trigName: string): void {
        // this.taskQueue = [];

        if (!this.triggerDict.has(trigName)) {
            console.log(`${trigName} is not a defined trigger`);
            return;
        }

        this.triggerDict.get(trigName)?.forEach(t => {
            let sub = this.subroutines[t];
            if(!(sub instanceof VoidBlock)) throw new InternalCompilerError('Subroutine not Void!');
            this.buildTaskQueue(sub.evalBlock(this.varEnv), sub.getLength());
        });

        this.scheduleNextTask();

    }

    /**
     * Schedules execution of the program to stop.
     */
    stop() {
        console.log('scheduling to stop!');
        interuptSignal = true;
    }


    /**
     * Schedules untriggered subroutines for execution.
     */
    run() {
        interuptSignal = false;
        this.taskQueue = []

        this.varEnv = new Map();

        this.subroutines.filter((val, ix) => !this.triggeredIndexes.has(ix))
            .forEach(task => {
                if(!(task instanceof VoidBlock)) throw new InternalCompilerError('Task is not a Void!');

                let gen = task.evalBlock(this.varEnv);
                this.buildTaskQueue(gen, task.getLength());
            });

        this.scheduleNextTask();

    }

    /**
     * Adds a task to the task queue
     * @param task task being added to queue
     */
    private buildTaskQueue(task: IterableIterator<void>, length: number) {
        this.taskQueue.push([task, length]);
    }

    /**
     * Recursive execution loop using requestAnimationFrame. Executsts the generator
     * cycle. If the current generator is done, it asks for the next task.
     * Stops executing if scheduled to stop.
     * 
     * @param task current task being worked on
     * @param length the number of steps to execute this task
     */
    private eventLoop(task: IterableIterator<void>, length: number) {
        if (interuptSignal) {
            this.stopCleanup();
            return;
        }
        let status;

        try {
            let count = 0;
            let s;

            do {
                s = task.next();
            } while (++count < length);

            status = s.done;

        } catch (err) {
            console.error(err);
            console.log('CAUGHT AN ERROR')

            interuptSignal = true;
            this.taskQueue = [];

            // eslint-disable-next-line eqeqeq
            if (err.name == 'TeaBlocksError') {
                console.log('TEABLOCKS ERROR!!!')
                this.errorNotify(err.message, err.id);
                console.log(err);
            } else {
                console.log('UNHANDLED ERROR!!');
                throw err;
            }

        }

        if (status) {
            this.scheduleNextTask();
        } else {
            window.requestAnimationFrame(_ => this.eventLoop(task, length));
            // setTimeout(_ => this.eventLoop(task, length), 0);
        }
    }

    /**
     * Schedules the next task for execution, if there is a next task.
     */
    private scheduleNextTask() {
        let nextTask = this.taskQueue.shift();
        if (nextTask == null) return;
        let [aaa, length] = nextTask;
        window.requestAnimationFrame(_ => this.eventLoop(aaa, length));
        // setTimeout(_ => this.eventLoop(aaa, length),0)

    }

    private stopCleanup() {
        this.varEnv = new Map();
        this.taskQueue = [];
    }
}